const PriceMovementGraphType = {
  priceMovements: "priceMovements",
  priceMovementsCumulative: "priceMovementsCumulative",
  contractPrices: "contractPrices",
};

export default PriceMovementGraphType;
